module.exports = "/img/_/_/_/assets/images/creeper/book/rare//empty.jpg?d7fb6ae3b3b9c7197c2fbcbfd8c53862";